import { useQuery } from '@tanstack/react-query';

import { Entity } from 'src/features/entity/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/entities/entity/:id/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    id: string;
}
const queryFn = ({ parkingId, id }: DTO): Promise<Entity> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, id }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as GET_ENTITY_RESOURCE, useQueryHook as useGetEntity };
